import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-scroll";
import { Typography } from "@material-tailwind/react";

import sgFlag from "../../assets/sg_flag.jpg";
import SocialIcons from "../SocialIcons/SocialIcons";
import "./Sidebar.css";

const SidebarLink = ({ to, activeSection, setActiveSection }) => (
  <Link
    to={to}
    spy={true}
    smooth="easeInQuad"
    duration={200}
    onSetActive={() => setActiveSection(to)}
    className={`sidebar-link ${activeSection === to ? "active-link" : ""}`}
  >
    {to}
  </Link>
);

SidebarLink.propTypes = {
  to: PropTypes.string.isRequired,
  activeSection: PropTypes.string.isRequired,
  setActiveSection: PropTypes.func.isRequired,
};

const Sidebar = ({ reveal }) => {
  const sections = ["home", "experiences", "projects", "academic"];
  const [activeSection, setActiveSection] = useState(sections[0]);

  return (
    <div className={`sidebar ${reveal ? "sidebar-visible" : ""}`}>
      <div className="sidebar-header">
        <Typography variant="h3" className="sidebar-name">
          Zheng Ting
        </Typography>
        <Typography className="sidebar-bio">
          A Software Engineering undergraduate from Singapore. {" "}
          <img className="flag" src={sgFlag} alt="Singapore flag." />
        </Typography>
      </div>
      <nav className="sidebar-nav">
        {sections.map((section) => (
          <SidebarLink
            key={section}
            to={section}
            activeSection={activeSection}
            setActiveSection={setActiveSection}
          />
        ))}
      </nav>
      <SocialIcons />
    </div>
  );
};

Sidebar.propTypes = {
  reveal: PropTypes.bool.isRequired,
};

export default Sidebar;
